export const parseMonthlyPayments = (payments: API.VehicleMonthlyPayment[]): Record<number, API.VehicleMonthlyPayment> => {
  return payments.reduce<Record<number, API.VehicleMonthlyPayment>>((res, item) => {
    res[item.vehicleId] = item
    return res
  }, {})
}
